import { QueryClient } from '@tanstack/vue-query'

/**
 * TanStack Query client factory with defaults tuned for admin surfaces
 * (Tech Stack §4.1, §4.5). Long-ish staleTime because admin data is read-heavy
 * and server-state invalidation is driven by explicit mutations + websocket
 * events once those land.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: (failureCount, error: unknown) => {
          // Do not retry on auth errors (401/403) or client errors (400-class).
          const status =
            typeof error === 'object' && error !== null && 'status' in error
              ? (error as { status: number }).status
              : 0
          if (status >= 400 && status < 500) return false
          return failureCount < 2
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  })
}

// Singleton instance used by the Vue plugin AND any module that needs
// imperative cache control (e.g. clearing on tenant change in stores/auth.ts).
// Keep this export stable — auth.ts imports it directly.
export const queryClient = createQueryClient()
